"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.productionUtils = void 0;
const lodash_1 = require("lodash");
const __1 = require("..");
const getProductGroups = (production) => {
    const productGroupsObject = (0, lodash_1.groupBy)(production || [], "productCode");
    const productGroups = Object.keys(productGroupsObject).map((productCode) => {
        const production = productGroupsObject[productCode];
        return {
            productCode,
            production,
        };
    });
    return (0, lodash_1.orderBy)(productGroups, "productCode", "asc");
};
const getStatusWeight = (productionItem) => {
    if (productionItem === null || productionItem === void 0 ? void 0 : productionItem.lockedAt)
        return 6;
    if ((productionItem === null || productionItem === void 0 ? void 0 : productionItem.status) === __1.EProductionStatus.sent)
        return 5;
    if ((productionItem === null || productionItem === void 0 ? void 0 : productionItem.status) === __1.EProductionStatus.baked)
        return 4;
    if ((productionItem === null || productionItem === void 0 ? void 0 : productionItem.status) === __1.EProductionStatus.modeled)
        return 3;
    if ((productionItem === null || productionItem === void 0 ? void 0 : productionItem.status) === __1.EProductionStatus.planned)
        return 2;
    if ((productionItem === null || productionItem === void 0 ? void 0 : productionItem.status) === __1.EProductionStatus.unplanned)
        return 1;
    if ((productionItem === null || productionItem === void 0 ? void 0 : productionItem.status) === __1.EProductionStatus.broken)
        return 0;
    return -1;
};
const isUnplanned = ({ status }) => {
    return status === __1.EProductionStatus.unplanned;
};
const hasHole = ({ hole }) => {
    return !!hole;
};
const hasNoHole = ({ hole }) => {
    return !hole;
};
exports.productionUtils = {
    getProductGroups,
    getStatusWeight,
    isUnplanned,
    hasHole,
    hasNoHole,
};
//# sourceMappingURL=productionUtils.js.map